import React, { Component } from 'react';
import { Button, Container, Col, Card, Row, InputGroup, Image, Form } from 'react-bootstrap';
import ImageCrop from '../ImageCrop/ImageCrop';
import Footers from '../../component/Footers/Footer';
import avatar from '../../avatar.svg';
import whitebgright from '../../containers/Images/white-bg-right.PNG';
import whitebgincorrect1 from '../../containers/Images/white-bg-incorrect1.PNG';
import whitebgincorrect2 from '../../containers/Images/white-bg-incorrect2.PNG';
import brightnessincorrect1 from '../../containers/Images/brightness-incorrect1.PNG';
import brightnessincorrect2 from '../../containers/Images/brightness-incorrect2.PNG';
import focusincorrect1 from '../../containers/Images/focus-incorrect1.PNG';
import focusincorrect2 from '../../containers/Images/focus-incorrect2.PNG';
import visibilityincorrect1 from '../../containers/Images/visibility-incorrect1.PNG';
import visibilityincorrect2 from '../../containers/Images/visibility-incorrect2.PNG';
import shouldersincorrect from '../../containers/Images/shoulders-incorrect.PNG';
import expressionincorrect from '../../containers/Images/expression-incorrect.PNG';
import spectaclesincorrect1 from '../../containers/Images/spectacles-incorrect1.PNG';
import spectaclesincorrect2 from '../../containers/Images/spectacles-incorrect2.PNG';
import headgearright from '../../containers/Images/headgear-right.PNG';
import headgearincorrect1 from '../../containers/Images/headgear-incorrect1.PNG';
import headgearincorrect2 from '../../containers/Images/headgear-incorrect2.PNG';
import Loader from '../../component/Loader/Loader';
import { withRouter } from 'react-router-dom'
import axios from 'axios';
import ErrorModal from '../../component/ErrorModal/ErrorModal';
import Headers from '../../component/Headers/Headers';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import MediaQuery from 'react-responsive';
import { authContext } from "../../adalConfig";
import Resizer from 'react-image-file-resizer';
import imageCompression from 'browser-image-compression';
import './PhotoGuide.css';


class PhotoGuide extends Component {
    constructor(props) {
        super(props);
        this.inputChangedRef = React.createRef();

        //this.handleClick = this.handleClick.bind(this);

        this.navigateToUpload = this.navigateToUpload.bind(this);
    }
    
    navigateToUpload() {
        // 👇️ navigate to /Upload
        let pathUpload = '/Upload'; 
        //this.props.history.push(pathUpload);

        this.props.history.push({
            pathname: '/Upload',
            state: {
                login: this.props.location.state.login,
                studentID: this.props.location.state.studentID,
                userType: this.props.location.state.userType,
                accesstoken: this.props.location.state.accesstoken
            }
        })
    };

    state = {
        imageUrl: null,
        imageName: "Choose file...",
        StudentID: '',
        StaffName: '',
        role: 'Student',
        isOHR: false,
        isOSE: false,
        checkSubmit: true

        //isLoading: false
        //accesstoken: this.props.location.state.accesstoken,
        //studentID: this.props.location.state.studentID
    };

    componentDidMount() {
        //authenticate whether user has login properly
        if (!this.props.location.state) {
            this.props.history.push('/')
        }
        //console.log('state', this.props.location.state)
        //console.log('role', this.props.role)

        //Check whether user type and show different upload page
        if (this.props.location.state) {
            console.log('userType', this.props.location.state.userType)
            if (this.props.location.state.userType === 'OSEAdmin') {
               // console.log(this.props.staffName, this.props.studentID)
                if (this.props.staffName && this.props.studentID && this.props.role) {
                    this.setState({
                        StudentID: this.props.studentID,
                        StaffName: this.props.staffName,
                        role: this.props.role,
                        isOSE: true,
                        userid: localStorage.getItem('id')
                    })
                } else if (this.props.location.state.staffName && this.props.location.state.studentID && this.props.location.state.role) {
                    this.setState({
                        StudentID: this.props.location.state.studentID,
                        StaffName: this.props.location.state.staffName,
                        role: this.props.location.state.role,
                        isOSE: true,
                        userid: localStorage.getItem('id')
                    })
                } else {
                    this.setState({
                        isOSE: true,
                        userid: localStorage.getItem('id')
                    })
                }
            } else if (this.props.location.state.userType === 'OHRStaff') {
                if (this.props.staffName && this.props.studentID) {
                    this.setState({
                        StudentID: this.props.studentID,
                        StaffName: this.props.staffName,
                        isOHR: true,
                        userid: localStorage.getItem('id')
                    })
                }  else if (this.props.location.state.staffName && this.props.location.state.studentID && this.props.location.state.userType) {
                    this.setState({
                        StudentID: this.props.location.state.studentID,
                        StaffName: this.props.location.state.staffName,
                        isOHR: true,
                        userid: localStorage.getItem('id')
                    })
                } else {
                    this.setState({
                        isOHR: true,
                        userid: localStorage.getItem('id')
                    })
                }
            } else {
                this.setState({
                    userid: localStorage.getItem('id')
                })
            }
        }

        // if (this.props.role) {
        //     this.setState({
        //         role: this.props.role
        //     })
        // }



        // if (this.props.staffName || this.props.studentID) {
        //     console.log(this.props.staffName, this.props.studentID)
        //     if (this.props.userType) {
        //         this.setState({
        //             StudentID: this.props.studentID,
        //             StaffName: this.props.staffName,
        //             role: this.props.userType
        //         })
        //     } else {
        //         this.setState({
        //             StudentID: this.props.studentID,
        //             StaffName: this.props.staffName
        //         })
        //     }

        // }
    }

    inputChanged = () => {
        this.setState({ isLoading: true });
    }

    render() {
        
        let image =
            <Col className="my-auto">
                <Image className="img-height" src={whitebgright} thumbnail />
            </Col>

        return (
            <div>
                <Headers user={this.state.userid} />
                <Container>
                    {this.state.isLoading ? <Loader isLoading={this.state.isLoading} /> : null}
                    {/* <MediaQuery minDeviceWidth={800}> */}
                        {/* <Row> */}
                            {/* <Col sm={12} md={7} lg={7} className="mx-auto">
                                {this.state.submit ? displayCropOption : displayUpload}
                            </Col> */}
                            <Col sm={10} className="mx-auto my-auto">
                                <div className='guidelines'>
                                <p><b>Photo Guidelines</b></p>
                                    <ol>
                                        <li>
                                            Photo must be
                                            <ul>
                                                <li>Taken within the last 1 year.</li>
                                                <li>In colour taken against a full plain white background.</li>
                                                <li>Clear, in sharp focus and not pixelated or distorted.</li>
                                                <li>In JPEG format (.jpeg or .jpg file extension) with minimum 480 x 640 resolution</li>
                                                <li>File size between 60KB and 500KB.</li>
                                            </ul>
                                        </li>
                                        <li>Facial features must be fully visible and taken at the full frontal view with neutral facial expression</li>
                                        <li>Spectacles must have clear and non-tinted lenses where eyes are clearly visible</li>
                                        <li>Headgear worn in accordance with religious or racial customs is acceptable but must not hide the facial features.</li>
                                    </ol>
                                
                                </div>
                                <div className='guidelines'>
                                <p><b>Sample Photo</b></p>
                                <table id="tblPhotoGuidelines" className="tblPhotoGuide" >
                                    <tr >
                                        <td>Photo must be in colour taken against a white background</td>
                                        <td>
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                            {image}
                                        {/* </MediaQuery> */}
                                        </td>
                                        <td className="width37">
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                        <Col className="my-auto left width50" >
                                            <Image className="img-height" src={whitebgincorrect1} thumbnail />
                                        </Col>
                                        <Col className="my-auto right width50">
                                            <Image className="img-height" src={whitebgincorrect2} thumbnail />
                                        </Col>
                                        {/* </MediaQuery> */}
                                        {/* <MediaQuery minDeviceWidth={1000}>
                                        
                                        </MediaQuery> */}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Photo taken with even brightness and without shadow</td>
                                        <td>
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                            {image}
                                        {/* </MediaQuery> */}
                                        </td>
                                        <td className="width37">
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                        <Col className="my-auto left width50">
                                            <Image className="img-height" src={brightnessincorrect1} thumbnail />
                                        </Col>
                                        <Col className="my-auto right width50">
                                            <Image className="img-height" src={brightnessincorrect2} thumbnail />
                                        </Col>
                                        {/* </MediaQuery> */}
                                        </td>
                                    </tr>
                                    <tr >
                                        <td >Photo must be clear, in sharp focus and not pixelated</td>
                                        <td >
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                            {image}
                                        {/* </MediaQuery> */}
                                        </td>
                                        <td className="width37">
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                        <Col className="my-auto left width50">
                                            <Image className="img-height" src={focusincorrect1} thumbnail />
                                        </Col>
                                        <Col className="my-auto right width50">
                                            <Image className="img-height" src={focusincorrect2} thumbnail />
                                        </Col>
                                        {/* </MediaQuery> */}
                                        
                                        </td>
                                    </tr>
                                    <tr >
                                        <td style={{"width":"45%"}}>Facial features must be fully visible and taken at the full-frontal view</td>
                                        <td >
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                            {image}
                                        {/* </MediaQuery> */}
                                        </td>
                                        <td style={{ "width":"37%"}}>
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                        <Col className="my-auto left width50">
                                            <Image className="img-height" src={visibilityincorrect1} thumbnail />
                                        </Col>
                                        <Col className="my-auto left width50">
                                            <Image className="img-height" src={visibilityincorrect2} thumbnail />
                                        </Col>
                                        {/* </MediaQuery> */}
                                        </td>
                                    </tr>
                                    <tr >
                                        <td>Shoulders and hair must be fully visible</td>
                                        <td>
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                            {image}
                                        {/* </MediaQuery> */}
                                        </td>
                                        <td className="width37">
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                        <Col className="my-auto left width50">
                                            <Image className="img-height" src={shouldersincorrect} thumbnail />
                                        </Col>
                                        {/* </MediaQuery> */}
                                        </td>
                                    </tr>
                                    <tr >
                                        <td>Facial expression should be neutral</td>
                                        <td>
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                            {image}
                                        {/* </MediaQuery> */}
                                        </td>
                                        <td className="width37">
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                        <Col className="my-auto left width50">
                                            <Image className="img-height" src={expressionincorrect} thumbnail />
                                        </Col>
                                        {/* </MediaQuery> */}
                                        </td>
                                    </tr>
                                    <tr >
                                        <td >Spectacles must have clear and non-tinted lenses where eyes are clearly visible</td>
                                        <td >
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                            {image}
                                        {/* </MediaQuery> */}
                                        </td>
                                        <td className="width37">
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                        <Col className="my-auto left width50">
                                            <Image className="img-height" src={spectaclesincorrect1} thumbnail />
                                        </Col>
                                        <Col className="my-auto right width50">
                                            <Image className="img-height" src={spectaclesincorrect2} thumbnail />
                                        </Col>
                                        {/* </MediaQuery> */}
                                        </td>
                                    </tr>
                                    <tr >
                                        <td>Headgear worn in accordance with religious or racial customs is acceptable but must not hide the facial features</td>
                                        <td >
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                        <Col className="my-auto" >
                                            <Image className="img-height" src={headgearright} thumbnail />
                                        </Col>
                                        {/* </MediaQuery> */}
                                        </td>
                                        <td className="width37">
                                        {/* <MediaQuery minDeviceWidth={1000}> */}
                                        <Col className="my-auto left width50">
                                            <Image className="img-height" src={headgearincorrect1} thumbnail />
                                        </Col>
                                        <Col className="my-auto right width50">
                                            <Image className="img-height" src={headgearincorrect2} thumbnail />
                                        </Col>
                                        {/* </MediaQuery> */}
                                        </td>
                                    </tr>
                                </table>
                                </div>
                                <div className="guidelines">
                                <div className="pb-2 pt-2 text-right">
                                    <table>
                                        <tr>
                                        <td>
                                    <Button variant="primary" onClick={this.navigateToUpload} >
                                        Continue
                                    </Button>
                                    </td>
                                    </tr>
                                    </table>
                                </div>
                                </div>
                            </Col>
                        {/* </Row> */}
                    {/* </MediaQuery> */}


                </Container>
                <ErrorModal msg={this.state.errorMsg} show={this.state.show} click={() => this.closeHandler()} />
                <Footers />
            </div>
        );
    }

}

export default withRouter(PhotoGuide);